/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var SortAscendingOutlineIcon = function SortAscendingOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M4.58889 8.5356L2.70712 10.4174L1.29291 9.00315L5.71012 4.58594L10.1273 9.00315L8.71312 10.4174L6.58889 8.29313L6.58888 18.1214L4.58888 18.1214L4.58889 8.5356Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.00014H18V8.00014H12V6.00014Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11.0001H12V13.0001H20V11.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.0001H12V18.0001H22V16.0001Z"
  }));
};
export default SortAscendingOutlineIcon;